import { useState } from "react";
import { useTranslation } from "react-i18next";
import Link from "@/components/feature/LocaleLink";

const ITEMS = [1, 2, 3, 4, 5] as const;

// 자주 묻는 질문: 검색 키워드(선박 IT 유지보수 · 위성통신 · 사이버보안 · 원격지원)를 자연스럽게 담고,
// FAQPage 구조화 데이터로 구글 검색 결과에 질문·답이 바로 노출되도록 합니다.
export default function FaqSection() {
  const { t } = useTranslation();
  const [open, setOpen] = useState<number>(1);

  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: ITEMS.map((i) => ({
      "@type": "Question",
      name: t(`faq.q${i}`),
      acceptedAnswer: { "@type": "Answer", text: t(`faq.a${i}`) },
    })),
  };

  return (
    <section id="faq" className="bg-background-50 py-24 md:py-32">
      <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      <div className="max-w-4xl mx-auto px-4 md:px-10">
        <div className="text-center mb-12" data-reveal>
          <p className="text-xs tracking-[0.3em] font-semibold text-[var(--brand-orange)] uppercase mb-4 font-label">{t("faq.eyebrow")}</p>
          <h2 className="font-heading text-3xl md:text-5xl font-bold text-foreground-950">{t("faq.title")}</h2>
        </div>

        <div className="divide-y divide-background-200 border-y border-background-200" data-reveal data-reveal-stagger>
          {ITEMS.map((i) => {
            const isOpen = open === i;
            return (
              <div key={i}>
                <button
                  type="button"
                  onClick={() => setOpen(isOpen ? 0 : i)}
                  aria-expanded={isOpen}
                  className="w-full flex items-center justify-between gap-4 py-5 text-left cursor-pointer"
                >
                  <h3 className="font-heading font-semibold text-foreground-950 text-base md:text-lg">{t(`faq.q${i}`)}</h3>
                  <i className={`ri-arrow-down-s-line text-xl text-foreground-500 shrink-0 transition-transform ${isOpen ? "rotate-180" : ""}`}></i>
                </button>
                {/* 답변은 항상 DOM 에 두어 검색엔진이 읽을 수 있게 하고, 닫힌 상태는 시각적으로만 숨김 */}
                <div className={`overflow-hidden transition-all ${isOpen ? "max-h-96 pb-5" : "max-h-0"}`}>
                  <p className="text-foreground-600 leading-relaxed text-sm md:text-base">{t(`faq.a${i}`)}</p>
                </div>
              </div>
            );
          })}
        </div>

        <div className="text-center mt-10">
          <Link
            to="/services"
            className="inline-flex items-center gap-2 text-sm font-semibold text-primary-600 hover:gap-3 transition-all cursor-pointer"
          >
            {t("faq.more")}
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}
